export const DEFAULT_MAINTENANCE_FILTERS = {
  minOdometer: null,
  maxOdometer: null,
  serviceType: null,
  minTotalCost: null,
  maxTotalCost: null,
}
